module.exports = __webpack_public_path__ + "static/Anheuser_Busch-7c7fd912fc7c40c0e230cc9393ccda8e.png";